import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import { isSessionValid } from "./profileAction";
import * as toastAction from "../actions/toastAction";
import * as apiServices from "../../services/apiServices";
import apiConfig, {
  DEFAULT_ERROR_MESSAGE,
  ERROR_TIMEOUT,
} from "../../App.config";
import { getCountry, getLoction, getState } from "./stdAction";
import { getJob } from "./commonAction"
import { getAllPendingApplications } from "./notificationAction";
import { setSuccessMessage } from "./commonAction";

/************************************ ACTIONS ****************************************/

function setMinimumFormStepAction(minSteps) {
  return {
    type: types.SET_AIR_MIN_STEPS,
    minSteps,
  };
}

function setMaximumFormStepAction(maxSteps) {
  return {
    type: types.SET_AIR_MAX_STEPS,
    maxSteps,
  };
}

function setCurrentFormStepAction(step) {
  return {
    type: types.SET_AIR_CURRENT_STEP,
    step,
  };
}

function setIsAddedAction(isAdded) {
  return {
    type: types.SET_AIR_IS_ADDED,
    isAdded,
  };
}

function setAirPendingApplications(pendingApplications) {
  return {
    type: types.SET_AIR_PENDING_APPLICATIONS,
    pendingApplications
  }
}

// function setPendingApplications(allPendingApplications) {
//   return {
//     type: types.SET_PENDING_APPLICATIONS,
//     allPendingApplications
//   }
// }

function setAirEmployeeStatement(airEmployeeStatememt) {
  return {
    type: types.SET_AIR_EMPLOYEE_STATEMENT,
    airEmployeeStatememt
  }
}

function setSupervisorListAction(supervisorList) {
  return {
    type: types.SET_SUPERVISOR_LIST,
    supervisorList,
  };
}

function setAirPdfLinkAction(airFormPdfLink) {
  return {
    type: types.SET_AIR_FORM_PDF,
    airFormPdfLink,
  };
}

function setAttachmentAction(attachment) {
  return {
    type: types.SET_ATTACHMENT,
    attachment,
  };
}
/************************************ ACTION CREATORS ****************************************/

export const prepareAirConfigData = () => (dispatch) => {
  dispatch(getCountry());
  dispatch(getState());
  dispatch(getJob());
  // dispatch(getEmploymentStatus());
  dispatch(getLoction());
  dispatch(getSupervisorListByCompany());
};


//Setting form step count

export const resetState = () => (dispatch) => {
  dispatch(setCurrentFormStep(1));
  //dispatch(setPendingApplications(undefined));
  dispatch(setAirEmployeeStatement(undefined));
};

export const setMaximumFormStep = (maxCount) => (dispatch) => {
  dispatch(setMaximumFormStepAction(maxCount));
};

export const setMinimumFormStep = (minCount) => (dispatch) => {
  dispatch(setMinimumFormStepAction(minCount));
};

export const setCurrentFormStep = (stepCount) => (dispatch) => {
  dispatch(setCurrentFormStepAction(stepCount));
};

export const resetIsAdded = (isAdded) => (dispatch) => {
  dispatch(setIsAddedAction(isAdded));
};

export const resetAirApplicationUrl = () => (dispatch) => {
  dispatch(setAirPdfLinkAction(undefined));
};

export const getSupervisorListByCompany = () => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getSupervisorListByCompany()
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setSupervisorListAction(data.listSupervisors));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const addAirEmployeeStatement = (airData, managerId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .addAirEmployeeStatement(airData)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(
          setAirPdfLinkAction(
            // data?.ersFormPDF?.fileUploadPath?.replace("~/", apiConfig.BASEURL)
            data?.ersFormPDF?.fileUploadPath
          )
        );
        dispatch(setSuccessMessage(data.successMessage));
        dispatch(setIsAddedAction(true));
        dispatch(setAttachmentAction([]));
        dispatch(getAllPendingApplications(managerId));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getPendingAirApplications = (managerId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getPendingAirApplications(managerId)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setAirPendingApplications(data.lstEmpInfo));
        dispatch(setLoaderAction(false));
        // dispatch(setIsAddedAction(true));
        // dispatch(setAttachmentAction([]));
        // dispatch(
        //   setAirPdfLinkAction(
        //     data?.ersFormPDF?.fileUploadPath.replace("~/", apiConfig.BASEURL)
        //   )
        // );
        // dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const resetAirEmployeeStatement = () => (dispatch) => {
  dispatch(setAirEmployeeStatement({}));
}

// export const getAllPendingApplications = (managerId) => (dispatch) => {
//   dispatch(setLoaderAction(true));
//   return apiServices
//     .getAllPendingApplications(managerId)
//     .then(({ data }) => {
//       if (dispatch(isSessionValid(data.errorMessage))) {
//         return;
//       }
//       if (data.isTransactionSucceed) {
//          dispatch(setPendingApplications(data.lstEmpInfo));
//         dispatch(setLoaderAction(false));
//         // dispatch(setIsAddedAction(true));
//         // dispatch(setAttachmentAction([]));
//         // dispatch(
//         //   setAirPdfLinkAction(
//         //     data?.ersFormPDF?.fileUploadPath.replace("~/", apiConfig.BASEURL)
//         //   )
//         // );
//         // dispatch(toastAction.showSuccessMessage(true, data.successMessage));
//         setTimeout(() => {
//           dispatch(toastAction.showSuccessMessage(false, ""));
//         }, ERROR_TIMEOUT);
//       } else {
//         if (data.errorMessage) {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, data.errorMessage));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         } else {
//           dispatch(setLoaderAction(false));
//           dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//           setTimeout(() => {
//             dispatch(toastAction.showErrorMessage(false, ""));
//           }, ERROR_TIMEOUT);
//         }
//       }
//     })
//     .catch((error) => {
//       dispatch(setLoaderAction(false));
//       dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
//       setTimeout(() => {
//         dispatch(toastAction.showErrorMessage(false, ""));
//       }, ERROR_TIMEOUT);
//     });
// };


export const getAirEmployeeStatement = (employerInformationId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAirEmployeeStatement(employerInformationId)
    .then(({ data }) => {
      dispatch(setLoaderAction(false));
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setAirEmployeeStatement(data));
        // dispatch(setIsAddedAction(true));
        // dispatch(setAttachmentAction([]));
        // dispatch(
        //   setAirPdfLinkAction(
        //     data?.ersFormPDF?.fileUploadPath.replace("~/", apiConfig.BASEURL)
        //   )
        // );
        // dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};